import React from 'react';
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import {Helmet} from 'react-helmet';
import { setActivitiesOpen } from '../../../actions/create-action'
import { Link } from 'react-router-dom';

import Menu from '../../Navigation/Menu'
import { store } from '../../../store';

import Navigation from '../../Navigation/Navigation';
import Footer from '../../Footer/Footer';
import {Grid, Row, Col} from 'react-bootstrap';

import BGshowcase3 from '../../../Images/landing_1.jpg';

import Step1 from '../../../Images/step_1.png';
import Step2 from '../../../Images/step_2.png';
import Step3 from '../../../Images/step_3.png';
import Step4 from '../../../Images/step_4.png';
import Step5 from '../../../Images/step_5.png';
import Step6 from '../../../Images/step_6.png';
import Step7 from '../../../Images/step_7.png';
import Step8 from '../../../Images/step_8.png';
const mapStateToProps = (state) => {
  let open = state.activities.open
  return {
    open: open,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onOpen: (open) => dispatch(setActivitiesOpen(open)),
  }
}

class Landing extends React.Component {
   constructor(props) {
      super()
      this.state = {
         visible:false,
         mouseOverbtn: false,
         clickInside: false,
         bgImg: false
      }
      this.myRef=null
      this.handleClickOutside = this.handleClickOutside.bind(this)
      this.onMenu = this.onMenu.bind(this)
   }
   componentWillMount() {
      this.setState({visible: true})
   }
   componentWillLeave() {
      this.setState({visible: false})
   }
   componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside)
  }
   componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }
  handleClickOutside(event) {
    if(this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      return;
    }
    else if(!this.state.clickInside)
      this.props.onOpen('')
  }
  onMenu = () => {
    if(store.getState().activities.open === 'menu')
    {
      this.props.onOpen('')
    }
    else this.props.onOpen('menu')
  }
  onClickInside = () => {
  this.setState({clickInside: true})
  }
  onClickOutside = () => {
    this.setState({clickInside: false})
  }
   render(props) {
      if(store.getState().user.isSignedIn)
      return <Redirect to='/dashboard' />
      return (
         <div className="container_home container_landing" ref={this.setWrapperRef}>
         <Helmet>
          <title>Vieww &mdash; Create free profile page sites for professional, business & personal use</title>  
          <meta name="description" content="Create profile sites for professional, business or personal card. A short-profile page which connects all your web profiles & your about, contact details" />
          <meta name="keyword" content="profile website, vieww profile, profiles, create onepage site, free profile, free site, create free profile page, professional profile, business profile" />
          <meta property="og:type" content="website" />
          <meta property="og:url" content="https://vieww.me" />
          <meta property="og:title" content="Vieww &mdash; Create free profile page sites for professional, business & personal use" />
          <meta name="og:description" content="Create profile sites for professional, business or personal card. A short-profile page which connects all your web profiles & your about, contact details" />
          <meta property="og:site_name" content="Vieww &mdash; Create free profile page sites for professional, business & personal use" />
          <meta property="twitter:card" content="summary_large_image" />
          <meta name="robots" content="index, follow" />
         </Helmet>
         <Grid fluid={true} className="container_create">
         <Row className="row_land">
         <Col lg={12} md={12} sm={12} xs={12} className="illum" />
         <div className={this.state.bgImg ? "illum_img_out" : "illum_img_out_blur"}><img onLoad={()=>this.setState({bgImg: true})} src={BGshowcase3} className="illum_img" /></div>
         <Col lg={12} md={12} sm={12} xs={12} className="illum_out">
         <Navigation 
            onClickInside={this.onClickInside}
            onClickOutside={this.onClickOutside}
            onMenu={this.onMenu}/>
         <div className="land hl_btn_container">
        <div className="hl_btn_container_content">
        <h2 className="home_subheading">Create your profile page website</h2>
        </div><br />
        <div className="hl_btn_container_content">
         <Link to={'/create'}><button className="btn_new">Get Started Free</button></Link>
        </div><br />
        <div className="hl_btn_container_content">
         <span className=" link_to lnk_to"><Link to={'/about'}>Why you need a profile page site?</Link></span>
        </div>
         </div>
         </Col>
         </Row>
         <Footer/>
         </Grid>
         {store.getState().activities.open === 'menu'
            ? <Menu
            onClickInside={this.onClickInside}
            onClickOutside={this.onClickOutside}
            onOpen={this.props.onOpen} />
            : null
          }
         </div>
      );
   }
   
  scrollToMyRef = () => window.scrollTo(0, this.myRef.offsetTop)
}

export default connect(mapStateToProps, mapDispatchToProps)(Landing);